import { getClosestConfigurationFromSeat } from '%paysera_seat_selection/js/seatSelection/redux/component/orm/services/getClosestConfiguration';
import {
    LABEL_ICON_DISABLED,
    LABEL_ICON_FOR_CASHIER,
    LABEL_ICON_RESERVED,
    SEAT_TYPE_CIRCLE,
} from '%paysera_seat_selection/js/seatSelection/config/constants';
import { extractSeatsFromParentOrdered } from '%paysera_seat_selection/js/seatSelection/redux/component/orm/services/extractSeatsFromSelection';
import calculateCollectionLabel from '%paysera_seat_selection/js/seatSelection/redux/component/orm/services/calculateCollectionLabel';
import calculateCircleSeatLabel from '%paysera_seat_selection/js/seatSelection/redux/component/orm/services/calculateCircleSeatLabel';
import seatEnumerationValidator from '%paysera_seat_selection/js/seatSelection/redux/component/orm/services/SeatEnumerationValidator';
import getSeatingMapObjectParent from '%paysera_seat_selection/js/seatSelection/services/getSeatingMapObjectParent';

function getEnabledSeatsCount(seats) {
    return seats.filter(seat => seat.enabled).length;
}

function getDisabledSeatsCountBeforeSeat(seats, seat) {
    return seats.filter(item => (item.index < seat.index && !item.enabled)).length;
}

function getLabelTransformation(seat) {
    const parent = getSeatingMapObjectParent(seat);
    let rotation = -parent.transformation.rotation;
    if (parent.sector) {
        rotation -= parent.sector.transformation.rotation;
    }

    return { rotation };
}

function compileSeatLabel(seat) {
    const { seatLabeling } = getClosestConfigurationFromSeat(seat, 'seatLabeling');
    const { fontConfig } = getClosestConfigurationFromSeat(seat, 'fontConfig');
    const { seatConfig } = getClosestConfigurationFromSeat(seat, 'seatConfig');

    if (seat.type === SEAT_TYPE_CIRCLE) {
        let itemPosition = seat.index + 1;
        const seats = extractSeatsFromParentOrdered(seat);

        const enabledSeatsCount = getEnabledSeatsCount(seats);
        if (seats.length > 0 && enabledSeatsCount !== seats.length) {
            itemPosition -= getDisabledSeatsCountBeforeSeat(seats, seat);
        }

        let { label: { text } } = seat;
        if (!seat.label.manual) {
            text = calculateCollectionLabel(seatLabeling, itemPosition, seats.length, enabledSeatsCount);
        }

        const label = calculateCircleSeatLabel(seat, seatConfig, fontConfig, text);
        seatEnumerationValidator.validateSeatEnumeration(seat, label);

        label.icon = null;
        if (seat.forCashier) {
            label.icon = LABEL_ICON_FOR_CASHIER;
        }
        if (!seat.enabled) {
            label.icon = LABEL_ICON_DISABLED;
        }
        if (seat.reservation !== null) {
            label.icon = LABEL_ICON_RESERVED;
        }

        seat.label = label;
    }

    seat.label = {
        ...seat.label,
        transformation: getLabelTransformation(seat),
    };

    return seat;
}

export default compileSeatLabel;
